import React from "react";

import Helmet from "react-helmet";
import Breadcrumbs from "../components/breadcrumbs";

const AboutPage = () => (
  <React.Fragment>
    <Helmet>
      <title>About Us</title>
    </Helmet>

    {/* <Breadcrumbs crumbs={[{ "Sign Awning": "/" }, "About Us"]} /> */}

    <header>
      <h2>About Us</h2>
    </header>

    <p>
      Sign Awning is a company run by a fully licensed specialist providing sign
      and awning services. Our State of California Contractors State License
      Board license number is 985058. We have three classifications including
      C45 - Electrical Signs, C61 / D42 - Sign Installation, and C61 / D03 -
      Awnings. We offer services for both business and property owners.
    </p>

    <br />

    <p>
      We are qualified to apply for permits for new, custom made signs and
      awnings. We handle the entire process ourselves, from planning to
      manufacturing and installation. We can also perform maintenance and
      repairs, however dire your needs may be. While we are more than capable of
      performing routine maintenance tasks on your signs, we also have the heavy
      duty lifting equipment necessary to provide emergency services when signs
      and awnings are damaged, whether it may be from environmental causes or
      vehicle-related accidents.
    </p>

    <br />

    <p>
      All of our sign and awning engineers are familiar with our entire
      process. We own welding machines, bending machines, heavy duty sewing
      machines, as well as computer cutting and printing equipment. We weld our
      own awning frames and sign supports. We bend metal tubes into curves for
      awning frames and sheet metal to cabinets for sign boxes. We perform
      custom sewing of fabric and vinyl for awning covers. We also digitally
      create graphics for signs.
    </p>

    <br />

    <p>
      With our C45 - Electrical Signs license, we are fully qualified to handle
      wiring, as well as installing LEDs, neon, and lamps for illumination.
    </p>

    <br />

    <p>
      If you're a property owner, we have services to help you as well. We are
      able to help you draft and submit Master Sign Programs. Our professional
      signs and awnings experts can also help you resolve violations and
      enforcement cases.
    </p>
  </React.Fragment>
);

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/about-us.js